import React, {useState, useEffect, useRef, useMemo} from 'react'
import {Col, FormGroup, Label, Row, Spinner} from "reactstrap";
import Select from "react-select";


const DependentCustomSelect = React.memo(({
    isDisabled = false,

    mainTitle = '',
    mainInitialValue = null,
    mainProvider = () => console.log('Provider not defined'),
    onChangeMain = () => console.log('onChangeMain not defined'),
    mainError= {},
    mainFilter= {},

    secondaryTitle = '',
    secondaryInitialValue = null,
    secondaryProvider = () => console.log('Provider not defined'),
    onChangeSecondary = () => console.log('onChangeSecondary not defined'),
    secondaryError= {},
    secondaryFilters= {},
  }) => {
    const [mainValue, setMainValue] = useState(null)
    const [mainComponentIsLoading, setMainComponentIsLoading] = useState(false)
    const [mainItems, setMainItems] = useState([])

    const [secondaryValue, setSecondaryValue] = useState(null)
    const [secondaryComponentIsLoading, setSecondaryComponentIsLoading] = useState(false)
    const [secondaryItems, setSecondaryItems] = useState([])


    const isMounted = useRef(true)


    // actualizar la referencia
    useEffect(() =>{
        return ()=>{
            isMounted.current = false
        }
    },[])



    // cargar los datos de la lista principal
    useEffect(() => {
        setMainComponentIsLoading(true)

        mainProvider.getOptions(mainFilter)
            .then( result => {
                if(!isMounted.current)
                    return

                if(result)
                    setMainItems(result)
            })
            .finally(() => {
                if(!isMounted.current)
                    return

                setMainComponentIsLoading(false)
            })
    }, [])



    // cargar los datos de la lista dependiente
    useEffect(() => {
        setSecondaryComponentIsLoading(true)

        secondaryProvider.getOptions(secondaryFilters)
            .then( result => {
                if(!isMounted.current)
                    return

                if(result)
                    setSecondaryItems(result)
            })
            .finally(() => {
                if(!isMounted.current)
                    return

                setSecondaryComponentIsLoading(false)
            })
    }, [mainValue])



    // cargar el item default de la lista principal
    useEffect(() => {
        if(!isMounted.current || !mainInitialValue || mainItems.length <= 0)
            return

        setMainComponentIsLoading(true)

        const item = mainItems.find( i => i.id === mainInitialValue)
        setMainValue(item)

        setMainComponentIsLoading(false)
    }, [mainItems, mainInitialValue])



    // cargar el item default de la lista dependiente
    useEffect(() => {
        if(!isMounted.current || !secondaryInitialValue || secondaryItems.length <= 0)
            return

        setSecondaryComponentIsLoading(true)

        const item = secondaryItems.find( i => i.id === secondaryInitialValue)
        setSecondaryValue(item)

        setSecondaryComponentIsLoading(false)
    }, [secondaryItems, secondaryInitialValue])


    const handleMainComponentChange = value => {
        setMainValue(value)
        onChangeMain(value?.id)
        handleSecondaryComponentChange(null)
    }


    const handleSecondaryComponentChange = value => {
        setSecondaryValue(value)
        onChangeSecondary(value?.id)
    }


    return <Row>
        <Col>
            <FormGroup>
                <Label>
                    <i className={ 'fa fa-plane' } aria-hidden='true' /> &nbsp;{ mainTitle }
                </Label>
                {
                    mainComponentIsLoading
                        ? <Spinner animation="border" style={{'display':'block'}}/>
                        : <Select
                            value={ mainValue }
                            options={ mainItems }
                            isDisabled={ isDisabled }
                            isClearable={ true }
                            onChange={ handleMainComponentChange }
                        />
                }
                {
                    mainError?.hasError && <span className="text-danger">{mainError.message}</span>
                }
            </FormGroup>
        </Col>
        <Col>
            <FormGroup>
                <Label>
                    <i className={ 'fa fa-plane' } aria-hidden='true' /> &nbsp;{ secondaryTitle }
                </Label>
                {
                    secondaryComponentIsLoading
                        ? <Spinner animation="border" style={{'display':'block'}}/>
                        : <Select
                            value={ secondaryValue }
                            options={ secondaryItems }
                            isDisabled={ isDisabled }
                            isClearable={ true }
                            onChange={ handleSecondaryComponentChange }
                        />
                }
                {
                    secondaryError?.hasError && <span className="text-danger">{secondaryError.message}</span>
                }
            </FormGroup>
        </Col>
    </Row>
})


export default DependentCustomSelect